import { TicketPriority, ticketPriorityIsValid } from '../../constants/Types';
import { DateRange } from '../../redux/dateRangeSlice';

export interface GetSolveAnalyticsStatsProps {
  range: DateRange,
  compareRange?: DateRange,
  buildingId: string,
  floorId?: string,
  areaId?: string,
  spaceId?: string,
  templateId?: string,
  templateGroupId?: string,
  userGroupId?: string,
  priority?: TicketPriority,
}

export const applySolveAnalyticsFilters = (
  baseUrl: string,
  {
    range, compareRange, buildingId, floorId, areaId, spaceId, templateGroupId, templateId,
    userGroupId, priority,
  }: GetSolveAnalyticsStatsProps,
) => {
  let url: string = baseUrl;
  url += `?startDate=${new Date(range.start).toISOString()}`;
  // url += `&from=${new Date(range.start).toISOString()}`;
  url += `&endDate=${new Date(range.end).toISOString()}`;
  // url += `&to=${new Date(range.end).toISOString()}`;
  if (compareRange?.start && compareRange?.end) {
    url += `&comparisonStartDate=${new Date(compareRange.start).toISOString()}`;
    url += `&comparisonEndDate=${new Date(compareRange.end).toISOString()}`;
  }
  if (templateId) url += `&templateId=${templateId}`;
  if (templateGroupId) url += `&templateGroupId=${templateGroupId}`;
  if (userGroupId) url += `&userGroupId=${userGroupId}`;
  if (spaceId) url += `&spaceId=${spaceId}`;
  else if (areaId) url += `&areaId=${areaId}`;
  else if (floorId) url += `&floorId=${floorId}`;
  else if (buildingId) url += `&buildingId=${buildingId}`;
  if (ticketPriorityIsValid(priority)) url += `&priority=${priority}`;
  return url;
};
